import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "make-model-search" };
const _hoisted_2 = {
    key: 0,
    class: "make-model-search__section"
};
const _hoisted_3 = { class: "search-box" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "brand-grid" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "brand-item__logo" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    key: 1,
    class: "brand-item__placeholder"
};
const _hoisted_10 = { class: "brand-item__name" };
const _hoisted_11 = {
    class: "show-all-button__icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
};
const _hoisted_12 = {
    key: 0,
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "16",
    stroke: "#faff00",
    "stroke-width": "2",
    "stroke-linecap": "round"
};
const _hoisted_13 = {
    key: 1,
    class: "model-selection"
};
const _hoisted_14 = {
    class: "breadcrumb",
    "aria-label": "Breadcrumb"
};
const _hoisted_15 = {
    key: 1,
    class: "breadcrumb__current"
};
const _hoisted_16 = {
    key: 2,
    class: "breadcrumb__sep"
};
const _hoisted_17 = {
    key: 3,
    class: "breadcrumb__current"
};
const _hoisted_18 = { class: "model-header" };
const _hoisted_19 = { class: "model-header__logo" };
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = {
    key: 1,
    class: "model-header__placeholder"
};
const _hoisted_22 = { class: "model-header__title" };
const _hoisted_23 = { class: "filter-bar" };
const _hoisted_24 = { class: "search-box search-box--table" };
const _hoisted_25 = ["src"];
const _hoisted_26 = ["placeholder"];
const _hoisted_27 = ["value"];
const _hoisted_28 = {
    key: 0,
    class: "models-table",
    ref: "modelsTableRef"
};
const _hoisted_29 = { class: "models-table__header" };
const _hoisted_30 = {
    key: 0,
    class: "sort-indicator"
};
const _hoisted_31 = {
    key: 0,
    class: "sort-indicator"
};
const _hoisted_32 = { class: "models-table__body" };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = { class: "models-table__cell" };
const _hoisted_35 = { class: "models-table__cell models-table__cell--year" };
const _hoisted_36 = {
    key: 0,
    class: "no-results"
};
import { onMounted, onUnmounted, ref, watch, computed, nextTick } from 'vue';
import { useOilFinder } from '../../composables/useOilFinder';
import { useStep } from '../../composables/useStep';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
import { useVehicleTypes } from '../../composables/useVehicleTypes';
import { useVehicleComponents } from '../../composables/useVehicleComponents';
import { useAssets } from '../../composables/useAssets';
import { useMakeModelSearch } from '../../composables/useMakeModelSearch';
import VehicleTypesTable from './VehicleTypesTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MakeModelSearch',
    setup(__props) {
        const { api } = useOilFinder();
        const { nextStep } = useStep();
        const { setVehicleDetails } = useVehicleDetails();
        const { setVehicleComponents } = useVehicleComponents();
        const { vehicleTypes, setVehicleTypes, setLoading, setError, clearVehicleTypes } = useVehicleTypes();
        const { assetUrl } = useAssets();
        const { makes, selectedMake, makeSearchQuery, models, selectedModel, modelSearchQuery, selectedYearFilter, showAllMakes, visibleMakesLimit } = useMakeModelSearch();
        // Control whether to show vehicle types table
        const showVehicleTypesTable = ref(false);
        // Search query for vehicle types
        const vehicleTypeSearchQuery = ref('');
        // Sorting for models table
        const sortKey = ref('title');
        const sortDirection = ref('asc');
        // Computed for current search query based on view
        const currentSearchQuery = computed({
            get: () => showVehicleTypesTable.value ? vehicleTypeSearchQuery.value : modelSearchQuery.value,
            set: (value) => {
                if (showVehicleTypesTable.value) {
                    vehicleTypeSearchQuery.value = value;
                }
                else {
                    modelSearchQuery.value = value;
                }
            }
        });
        // Current year for open-ended ranges and option generation
        const CURRENT_YEAR = new Date().getFullYear();
        // Function to update the limit based on window width
        const updateVisibleMakesLimit = () => {
            const width = window.innerWidth;
            // These breakpoints should match your SASS breakpoints
            if (width < 576) { // sm
                visibleMakesLimit.value = 18; // 3 columns × 6 rows
            }
            else if (width < 768) { // md
                visibleMakesLimit.value = 24; // 4 columns × 6 rows
            }
            else if (width < 992) { // lg
                visibleMakesLimit.value = 30; // 5 columns × 6 rows
            }
            else {
                visibleMakesLimit.value = 42; // 7 columns × 6 rows (default)
            }
        };
        // Helpers to normalize numbers
        const toNum = (v) => {
            if (v === null || v === undefined || v === '')
                return undefined;
            const n = Number(v);
            return Number.isFinite(n) ? n : undefined;
        };
        const getYearStart = (t) => toNum(t.year_start);
        const getYearEnd = (t) => toNum(t.year_end);
        // Build min/max from current models (fallback if no data yet)
        const yearBounds = computed(() => {
            let min = Infinity;
            let max = -Infinity;
            for (const m of models.value) {
                const start = getYearStart(m);
                const end = getYearEnd(m);
                if (start !== undefined) {
                    min = Math.min(min, start);
                    max = Math.max(max, end ?? CURRENT_YEAR);
                }
            }
            if (!Number.isFinite(min) || !Number.isFinite(max)) {
                min = 1990;
                max = CURRENT_YEAR;
            }
            return { min: min, max: max };
        });
        // Dropdown options: All years, After 1994, Before 1994, then each year (descending)
        const yearOptions = computed(() => {
            const { min, max } = yearBounds.value;
            const opts = [
                { value: '', label: 'All years' },
                { value: 'after-1994', label: 'After 1994' },
                { value: 'before-1994', label: 'Before 1994' },
            ];
            for (let y = max; y >= min; y--) {
                opts.push({ value: String(y), label: String(y) });
            }
            return opts;
        });
        // Computed property for filtered makes based on search
        const filteredMakes = computed(() => {
            if (!makeSearchQuery.value)
                return makes.value;
            const query = makeSearchQuery.value.toLowerCase();
            return makes.value.filter((make) => make.title.toLowerCase().includes(query));
        });
        // Computed property for visible makes (with show more/less functionality)
        const visibleMakes = computed(() => {
            const filtered = filteredMakes.value;
            if (makeSearchQuery.value)
                return filtered; // show all when searching
            if (showAllMakes.value)
                return filtered;
            return filtered.slice(0, visibleMakesLimit.value);
        });
        // Computed property to check if show more button should be displayed
        const shouldShowMoreButton = computed(() => {
            return !makeSearchQuery.value && filteredMakes.value.length > visibleMakesLimit.value;
        });
        // Format year range for display (year_start/year_end)
        const formatYearRange = (model) => {
            const y1 = getYearStart(model);
            const y2 = getYearEnd(model);
            if (y1 !== undefined && y2 !== undefined) {
                return `${y1} - ${y2}`;
            }
            if (y1 !== undefined) {
                return `${y1} -`;
            }
            return 'N/A';
        };
        // Check if model matches year filter
        // Supports: '', 'before-1994', 'after-1994', or a single year like '2018'
        const matchesYearFilter = (model) => {
            const val = selectedYearFilter.value;
            if (!val)
                return true;
            const start = getYearStart(model);
            const end = getYearEnd(model) ?? CURRENT_YEAR;
            if (start === undefined)
                return false;
            if (val === 'before-1994') {
                // Any overlap with <= 1993
                return start <= 1993;
            }
            if (val === 'after-1994') {
                // Any overlap with 1994+
                return end >= 1994;
            }
            // Single-year selection, e.g., "2018"
            if (/^\d{4}$/.test(val)) {
                const target = Number(val);
                return start <= target && target <= end;
            }
            return true;
        };
        // Computed property for filtered models
        const filteredModels = computed(() => {
            let filtered = models.value;
            // Filter by search query (search in model_title, title, and make_title)
            if (modelSearchQuery.value) {
                const q = modelSearchQuery.value.toLowerCase();
                filtered = filtered.filter((m) => (m.model_title && m.model_title.toLowerCase().includes(q)) ||
                    (m.title && m.title.toLowerCase().includes(q)) ||
                    (m.make_title && m.make_title.toLowerCase().includes(q)) ||
                    (m.code && m.code.toLowerCase().includes(q)));
            }
            // Filter by year
            filtered = filtered.filter(matchesYearFilter);
            return filtered;
        });
        // Computed property for sorted models
        const sortedModels = computed(() => {
            return [...filteredModels.value].sort((a, b) => {
                let aVal = a[sortKey.value];
                let bVal = b[sortKey.value];
                // Handle years specially
                if (sortKey.value === 'years') {
                    aVal = `${a.year_start}-${a.year_end}`;
                    bVal = `${b.year_start}-${b.year_end}`;
                }
                if (aVal < bVal)
                    return sortDirection.value === 'asc' ? -1 : 1;
                if (aVal > bVal)
                    return sortDirection.value === 'asc' ? 1 : -1;
                return 0;
            });
        });
        // Sort models by key
        const sortBy = (key) => {
            if (sortKey.value === key) {
                sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
            }
            else {
                sortKey.value = key;
                sortDirection.value = 'asc';
            }
        };
        // Toggle show all makes
        const toggleShowAll = () => {
            showAllMakes.value = !showAllMakes.value;
        };
        onMounted(async () => {
            // Set initial limit
            updateVisibleMakesLimit();
            // Add resize listener
            window.addEventListener('resize', updateVisibleMakesLimit);
            try {
                makes.value = await api.getVehicleMakes(1);
            }
            catch (error) {
                console.error('Failed to load makes:', error);
                try {
                    const categories = await api.getVehicleCategories();
                    if (categories.length > 0) {
                        makes.value = await api.getVehicleMakes(categories[0].id);
                    }
                }
                catch (fallbackError) {
                    console.error('Fallback also failed:', fallbackError);
                }
            }
        });
        // Cleanup resize listener
        onUnmounted(() => {
            window.removeEventListener('resize', updateVisibleMakesLimit);
        });
        // Handle make click
        const handleMakeClick = (make) => {
            selectedMake.value = make;
            clearVehicleTypes(); // Clear vehicle types when selecting a new make
        };
        // Handle model click
        async function handleModelClick(model) {
            try {
                setLoading(true);
                const response = await api.getVehicleTypesByModelId(model.id);
                if (response.success && response.data) {
                    setVehicleTypes(response.data);
                    // Store the selected model for potential UI feedback
                    selectedModel.value = model;
                    // Wait for DOM to update, then show vehicle types table
                    await nextTick();
                    showVehicleTypesTable.value = true;
                }
                else {
                    setError(response.error || 'Failed to find vehicle');
                }
            }
            catch (err) {
                console.error('Failed to search by model id:', err);
                setError('An error occurred while searching');
            }
            finally {
                setLoading(false);
            }
        }
        // Handle vehicle selection from the table
        const handleVehicleSelect = (type) => {
            processVehicleType(type.id);
        };
        // Function to process API call and step
        async function processVehicleType(vehicleId) {
            const response = await api.getProductRecommendations(vehicleId);
            setVehicleDetails(response.data.vehicle);
            setVehicleComponents(response.data.recommendations);
            nextStep();
        }
        // Reset make selection
        const resetMakeSelection = () => {
            selectedMake.value = null;
            selectedModel.value = null;
            models.value = [];
            modelSearchQuery.value = '';
            selectedYearFilter.value = 'after-1994';
            showVehicleTypesTable.value = false;
            vehicleTypeSearchQuery.value = '';
            clearVehicleTypes(); // Clear the vehicle types list when going back
        };
        // Go back to models view
        const goBackToModels = () => {
            showVehicleTypesTable.value = false;
            vehicleTypeSearchQuery.value = ''; // Optional: clear search when going back
        };
        // Handle image error - fallback to placeholder
        const handleImageError = (event) => {
            const img = event.target;
            if (img)
                img.style.display = 'none';
        };
        // Watch for make changes and load models/types
        watch(selectedMake, async (newMake) => {
            if (newMake) {
                try {
                    // IMPORTANT: ensure this endpoint returns VehicleType[]
                    models.value = await api.getVehicleModels(newMake.id);
                    selectedModel.value = null;
                    modelSearchQuery.value = '';
                    selectedYearFilter.value = 'after-1994';
                }
                catch (error) {
                    console.error('Failed to load models:', error);
                }
            }
            else {
                models.value = [];
                selectedModel.value = null;
                modelSearchQuery.value = '';
                selectedYearFilter.value = 'after-1994';
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_unref(selectedMake))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "make-model-search__heading" }, "Car brands", -1)),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                class: "search-box__icon",
                                src: _unref(assetUrl)('/images/trade-site/search-thicker.svg'),
                                alt: ""
                            }, null, 8, _hoisted_4),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(makeSearchQuery) ? (makeSearchQuery).value = $event : null)),
                                type: "text",
                                placeholder: "Search by car brand",
                                class: "search-box__input"
                            }, null, 512), [
                                [_vModelText, _unref(makeSearchQuery)]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMakes.value, (make) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: make.id,
                                    onClick: ($event) => (handleMakeClick(make)),
                                    class: "brand-item"
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        (make.image)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: make.image,
                                                alt: make.title,
                                                onError: handleImageError
                                            }, null, 40, _hoisted_8))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(make.title.charAt(0)), 1))
                                    ]),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(make.title), 1)
                                ], 8, _hoisted_6));
                            }), 128))
                        ]),
                        (shouldShowMoreButton.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: toggleShowAll,
                                class: "show-all-button"
                            }, [
                                _createTextVNode(_toDisplayString(_unref(showAllMakes) ? 'Show less brands' : 'Show all brands') + " ", 1),
                                (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                                    _cache[5] || (_cache[5] = _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        fill: "#00264C"
                                    }, null, -1)),
                                    (!_unref(showAllMakes))
                                        ? (_openBlock(), _createElementBlock("line", _hoisted_12))
                                        : _createCommentVNode("", true),
                                    _cache[6] || (_cache[6] = _createElementVNode("line", {
                                        x1: "8",
                                        y1: "12",
                                        x2: "16",
                                        y2: "12",
                                        stroke: "#faff00",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round"
                                    }, null, -1))
                                ]))
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("nav", _hoisted_14, [
                            _createElementVNode("a", {
                                onClick: resetMakeSelection,
                                class: "breadcrumb__link"
                            }, "Cars"),
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "breadcrumb__sep" }, "//", -1)),
                            (showVehicleTypesTable.value)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: goBackToModels,
                                    class: "breadcrumb__link"
                                }, _toDisplayString(_unref(selectedMake).title), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(selectedMake).title), 1)),
                            (showVehicleTypesTable.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "//"))
                                : _createCommentVNode("", true),
                            (showVehicleTypesTable.value && _unref(selectedModel))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(selectedModel).title), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                (_unref(selectedMake)?.image)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(selectedMake).image,
                                        alt: _unref(selectedMake).title,
                                        onError: handleImageError
                                    }, null, 40, _hoisted_20))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(selectedMake)?.title.charAt(0)), 1))
                            ]),
                            _createElementVNode("h1", _hoisted_22, _toDisplayString(_unref(selectedMake).title), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("img", {
                                    class: "search-box__icon",
                                    src: _unref(assetUrl)('/images/trade-site/search-thicker.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_25),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((currentSearchQuery).value = $event)),
                                    type: "text",
                                    placeholder: showVehicleTypesTable.value ? 'Search vehicle types' : 'Search car model name',
                                    class: "search-box__input"
                                }, null, 8, _hoisted_26), [
                                    [_vModelText, currentSearchQuery.value]
                                ])
                            ]),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(selectedYearFilter) ? (selectedYearFilter).value = $event : null)),
                                class: "year-dropdown",
                                style: _normalizeStyle({ backgroundImage: `url(${_unref(assetUrl)('/images/trade-site/down-arrow.svg')})` })
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (opt) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: opt.value,
                                        value: opt.value
                                    }, _toDisplayString(opt.label), 9, _hoisted_27));
                                }), 128))
                            ], 4), [
                                [_vModelSelect, _unref(selectedYearFilter)]
                            ])
                        ]),
                        (!showVehicleTypesTable.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", {
                                        onClick: _cache[3] || (_cache[3] = ($event) => (sortBy('title'))),
                                        class: "models-table__cell models-table__cell--header sortable"
                                    }, [
                                        _cache[9] || (_cache[9] = _createTextVNode(" Name ", -1)),
                                        (sortKey.value === 'title')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", {
                                        onClick: _cache[4] || (_cache[4] = ($event) => (sortBy('years'))),
                                        class: "models-table__cell models-table__cell--header sortable"
                                    }, [
                                        _cache[10] || (_cache[10] = _createTextVNode(" Manufacturing year ", -1)),
                                        (sortKey.value === 'years')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(sortDirection.value === 'asc' ? '▲' : '▼'), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedModels.value, (model) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: model.id,
                                            onClick: ($event) => (handleModelClick(model)),
                                            class: _normalizeClass(["models-table__row", { 'models-table__row--selected': _unref(selectedModel)?.id === model.id }])
                                        }, [
                                            _createElementVNode("div", _hoisted_34, _toDisplayString(model.title) + " (" + _toDisplayString(model.code) + ")", 1),
                                            _createElementVNode("div", _hoisted_35, _toDisplayString(formatYearRange(model)), 1)
                                        ], 10, _hoisted_33));
                                    }), 128))
                                ]),
                                (sortedModels.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[11] || (_cache[11] = [
                                            _createElementVNode("p", null, "No models found matching your search criteria.", -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ], 512))
                            : (_openBlock(), _createBlock(VehicleTypesTable, {
                                key: 1,
                                "vehicle-types": _unref(vehicleTypes),
                                "on-vehicle-select": handleVehicleSelect,
                                "search-query": vehicleTypeSearchQuery.value,
                                "selected-year-filter": _unref(selectedYearFilter)
                            }, null, 8, ["vehicle-types", "search-query", "selected-year-filter"]))
                    ]))
            ]));
        };
    }
});
